var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-header"},[_c('div',{staticClass:"header-content"},[_c('div',{staticClass:"icon-wrapper"},[_c('font-awesome-icon',{staticClass:"header-icon",attrs:{"icon":['fas', 'lightbulb']}})],1),_c('span',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }